import "./Footer.css";

const Footer = () => (
    <footer className="footer">
        <a
            href="https://github.com/Sahand2020"
            target="_blank"
            rel="noreferrer"
            className="link footer_link"
        >
            Created By Sahand Torabnejad
        </a>
    </footer>
);

export default Footer;
